import React from "react";
const Information = function Information(props) {
    return (
        <div className="section">
            <h2 className="title is-2">General Information</h2>
            <p>
                Nebraska approval regulations (Rule 14) and accreditation regulations (Rule 10) require that certain
                percentages of F.T.E. (Full Time Equivalency) elementary and middle grade teachers hold appropriate
                endorsements and that certain percentages of instructional units at the secondary grades be assigned to
                teachers holding appropriate endorsements.
            </p>
            <br />
            <table className="table is-bordered is-striped">
                <thead>
                    <tr>
                        <th>Grade Level</th>
                        <th>Rule 10</th>
                        <th>Rule 14</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Elementary</td>
                        <td>95%</td>
                        <td>90%</td>
                    </tr>
                    <tr>
                        <td>Middle</td>
                        <td>90%</td>
                        <td>80%</td>
                    </tr>
                    <tr>
                        <td>High School</td>
                        <td>80%</td>
                        <td>70%</td>
                    </tr>
                </tbody>
            </table>
            <p>For teachers to be considered appropriately endorsed for their assignments, they must teach the grade
                levels and subjects indicated on their certificate. The grade level designations are shown on the following
                chart.</p>


                <h2 className="title is-2">Endorsement Level</h2>
            <table className="table is-bordered is-striped">
                <thead>
                <tr>                    
                    <th>Certificates issued prior to January 1, 2020</th>
                    <th>Certificates issued after January 1, 2020 per Rule 24</th>
                </tr>
                </thead>
                <tbody>
                <tr>                    
                    <td>Prekindergarten (PK)</td>
                    <td>Prekindergarten (PK)</td>
                </tr>
                <tr>                    
                    <td>Pre-Primary – Age 3 (all schools) (Pre Primary - 3)</td>
                    <td>Birth-Age 3 (B-3)</td>
                </tr>
                <tr>                    
                    <td>Kindergarten - Grade 6 (K-6)</td>
                    <td>Kindergarten - Grade 6 (K-6)</td>
                </tr>
                <tr>                    
                    <td>Kindergarten - Grade 8 (K-8)</td>
                    <td>Kindergarten - Grade 8 (K-8)</td>
                </tr>
                <tr>                    
                    <td>Grades 7-9 (7-9)</td>
                    <td>Grades 7-9 (7-9)</td>
                </tr>
                <tr>                    
                    <td>Kindergarten - Grade 9 (K-9)</td>
                    <td>No Longer Used</td>
                </tr>
                <tr>                    
                    <td>Grades 7-12 (7-12)</td>
                    <td>Grades 7-12 (7-12)</td>
                </tr>
                <tr>                    
                    <td>Kindergarten - Grade 12 (K-12)</td>
                    <td>Kindergarten - Grade 12 (K-12)</td>
                </tr>
                <tr>                    
                    <td>Grades 9-12 (9-12)</td>
                    <td>Grades 9-12 (9-12)</td>
                </tr>
                <tr>                    
                    <td>Grades 4-9 (4-9)</td>
                    <td>No Longer Used (Converted to 5-9)</td>
                </tr>
                <tr>                    
                    <td>Birth - Grade 12 (B-12)</td>
                    <td>Birth - Grade 12 (B-12) <br />(Endorsement Specific - Ex: Audiologist / VI)</td>
                </tr>
                <tr>                    
                    <td>Birth-Kindergarten (B-K)</td>
                    <td>Birth - Prekindergarten (B-PreK)</td>
                </tr>
                <tr>                    
                    <td>Birth-Age 3 (B-3)</td>
                    <td>Birth-Age 3 (B-3)</td>
                </tr>
                <tr>                    
                    <td>Prekindergarten-Grade 6 (PK-6)</td>
                    <td>Prekindergarten-Grade 6 (PK-6)</td>
                </tr>
                <tr>                    
                    <td>Prekindergarten-Grade 8 (PK-8)</td>
                    <td>Prekindergarten-Grade 8 (PK-8)</td>
                </tr>
                <tr>                    
                    <td>Prekindergarten-Grade 12 (PK-12)</td>
                    <td>Prekindergarten-Grade 12 (PK-12) (Endorsement Specific)</td>
                </tr>
                <tr>                    
                    <td>Grades 10-12</td>
                    <td>No Longer Used</td>
                </tr>
                <tr>                    
                    <td>Prekindergarten-Grade 9 (PK-9)</td>
                    <td>No Longer Used</td>
                </tr>
                <tr>                    
                    <td>Grades 6-12 (6-12)</td>
                    <td>Grades 6-12 (6-12)</td>
                </tr>
                <tr>                    
                    <td>Birth-Age 21 (B-21)</td>
                    <td>Birth-Age 21 (B-21)<br />(Endorsement Specific - Ex: Speech Path.)</td>
                </tr>
                <tr>                    
                    <td>Prekindergarten-Grade 3 (PK-3)</td>
                    <td>Not a NE Grade Level<br />(Only used for out-of-state college programs)</td>
                </tr>
                <tr>                    
                    <td>Birth-Prekindergarten (B-PK)</td>
                    <td>Birth-Prekindergarten (B-PK)<br />(Only used for Early Interventionist - SE)</td>
                </tr>
                <tr>                    
                    <td>Grades 5-9 (5-9)</td>
                    <td>Grades 5-9 (5-9)</td>
                </tr>
                </tbody>
            </table>
            <p>
                <i>
                The following items represent flexibilities currently allowed in Section 007 of Rule 10 and Sections 005,
                006, and 007 of Rule 14. The remainder pages show course codes for specific content areas taught in
                Nebraska schools and the appropriate endorsements needed to clear. Courses where there is no specific
                endorsement required (8888), the grade level of endorsement must still be appropriate for the
                assignment.
                </i>
            </p>
            <p>
                <br /><br />
                <strong>Middle Grades:</strong>
                <br />
            1) A middle level endorsement can be applied to the endorsed subjects for which it is issued in
                grades 5-9 whether these grades are designated as part of an elementary, or a middle school.
                <br /><br />
            2) For grades 7 to 9, a middle level endorsement or an appropriate secondary endorsement is
                appropriate in the subject area(s) listed, if proper college credits or training are provided (see
                Item #5 below).
                <br /><br />
            3) Teachers holding an elementary endorsement may teach any subject in grades seven and eight
                if they acquire six credit hours per year towards a middle level endorsement or if they participate
                in staff development in accordance with a local mission or plan for education of middle grade
                students.
                <br /><br />
            4) Teachers holding a content area endorsement at the secondary level may teach grade six in
                that content area if they acquire six credit hours per year toward the elementary or middle level
                endorsement or participate in staff development in accordance with a local mission and plan for
                education of middle grade students.
                <br /><br />
            5) Secondary teachers may be assigned to teach integrated courses in grades 7 through 9 if they
                hold an endorsement for any of the subjects or fields included in the course.
                <br /><br />
            6) Teachers not holding an appropriate endorsement may be assigned to the middle grades if they
                acquire six credit hours per year towards a middle level endorsement.
                <br /><br />
                </p>
            <p>
                <br />
                <strong>Secondary Grades:</strong>
                <br />
            7) In secondary grades, teachers assigned to integrated courses or curriculum are considered
                appropriately endorsed if they hold an endorsement for the content area in which credit will be
                given (e.g. If English Language Arts credit is to be given in a Health Science Career Academy,
                the teacher should hold the appropriate endorsement for English Language Arts).
                <br /><br />
            8) Course descriptions in this manual shown for grades 10, 11, and 12 are intended to describe
                higher level courses. If, however, the course is taught at a 9th grade level, the appropriate middle
                level endorsement will cover the assignment.
                <br /><br />
                </p>
            <p>
                <strong>Elementary Grades:</strong>
                <br />
            9) Teachers holding an elementary endorsement that also includes grades 7-8 (K-8 in self-contained
                classrooms) are considered endorsed in grades 7-8 only if the students they are
                teaching remain with them for over 50% of their school day, and they are teaching over 50% of
                the academic curriculum to those same students.
            </p>
        </div>
    );
};

export default Information;
